// eslint-disable-next-line no-restricted-imports
import en from '~/lib/locales/en.json';
// eslint-disable-next-line no-restricted-imports
import fa from '~/lib/locales/fa.json';
// eslint-disable-next-line no-restricted-imports
import apt from '~/lib/locales/apt.json';

export default defineI18nConfig(() => ({
    fallbackLocale: 'fa',
    locale: 'fa',
    messages: {
        en,
        fa,
        apt,
    },
}));
